import * as angular from 'angular';

class StoragePriceUnitComponentCtrl implements ng.IController {
    public unit: StorageBiddingPriceUnitDto;
    public componentDisabled: boolean;
}

angular.module('app').component('pkpStoragePriceUnit', {
    controller: StoragePriceUnitComponentCtrl,
    template: require('app/storage-offer/storage-price-unit.component.html'),
    bindings: {
        componentDisabled: '<',
        unit: '<'
    }
});
